import { useState, useRef, useCallback, useMemo, useEffect, useLayoutEffect } from "react";

import { Box, Button, FormControl, FormControlLabel, Input, MenuItem, RadioGroup, Radio, Select, Tooltip } from "@mui/material";
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton } from "@mui/material";
import { PopupContext, usePopup, type PopupOption, type PopupAction } from "@components/popup/popup_context";

interface Props {
  children: React.ReactNode;
  onClose: (data?: any) => void;
}

export default function PopupCommon(props: Props) {
  const [option, setOption] = useState<PopupOption>({title: "", maxWidth: "1000px"});
  const [actions, setActions] = useState<PopupAction[]>([]);

  const closePopupRef = useRef(closePopup);
  const handleClose = useCallback((data?: any) => closePopupRef.current(data), []);

  const contextValue = useMemo(
  () => ({ option, setOption, actions, setActions, onClose: handleClose }),
    [option, actions]
  );

  useLayoutEffect(() => {
    closePopupRef.current = closePopup;
  });  

  function closePopup(data?: any) {
    props.onClose(data);
  }

  return (
    <>
      {/* 팝업 */}
      <Dialog
        sx={{ "& .MuiDialog-container": { "& .MuiPaper-root": { width: "100%", maxWidth: option.maxWidth, }, }, }}
        aria-labelledby="customized-dialog-title"
        open={true}
        onClose={(_e, reason) => {
          if (reason === "escapeKeyDown") {
            closePopup();
          }
        }}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          { option.title }
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={() => closePopup()}
          sx={(theme) => ({
            position: "absolute",
            right: 36,
            top: 24,
            color: theme.palette.grey[500],
          })}
        >
        </IconButton>
        <DialogContent>
          <PopupContext.Provider value={contextValue}>
            { props.children }
          </PopupContext.Provider>
        </DialogContent>
        <DialogActions>
          <div>
            {actions.filter(action => action.position == "left").map((action) => (
              <Button
                key={action.id}
                className={action.className}
                variant={action.variant}
                autoFocus={action.autoFocus}
                disabled={action.disabled}
                onClick={action.onClick}
              >
                { action.label }
              </Button>
            ))}
          </div>
          {actions.filter(action => action.position == undefined || action.position == "right").map((action) => (
            <Button
              key={action.id}
              className={action.className}
              variant={action.variant}
              autoFocus={action.autoFocus}
              disabled={action.disabled}
              onClick={action.onClick}
            >
              { action.label }
            </Button>
          ))}
        </DialogActions>
      </Dialog>
      {/*// 팝업 */}
    </>
  );
}
